<script>
    import { onMount } from "svelte";
    import { fly } from 'svelte/transition';
    import { quintOut } from 'svelte/easing';

    import { getAuth, signOut } from "firebase/auth";

    import { users, count, newUser, restrictions } from "../store/users";
    import { page, modal } from '../store/nav';

    import Icon from "../components/icon.svelte";

    export let back_nav = false;

    onMount(async () => {
        await users.init();
    });

    async function add(){
        console.log(newUser);
        await users.add(newUser);
        modal.open(`/update-user?user_uid=${newUser.uid}&anchor=bottom`);
    };
</script>

<section id="profile" in:fly="{{ x: back_nav ? -250 : 250, duration: 150 }}"  out:fly="{{ x: 250, duration: 150, delay:150 }}" class="z-0 fixed top-0 left-0 h-screen w-screen font-primaryBold text-primary flex flex-col justify-between pt-5 px-7 bg-secondary" >
    <section id="profile-top-bar" class="flex justify-between items-stretch ">
        <div id="back-btn" class="h-12 w-10" on:click|stopPropagation={page.referrer}>
            <svg width="18" height="18" viewBox="0 0 18 18" class="fill-primary m-auto mt-3.5" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7803 2.46967C12.0732 2.76256 12.0732 3.23744 11.7803 3.53033L6.31066 9L11.7803 14.4697C12.0732 14.7626 12.0732 15.2374 11.7803 15.5303C11.4874 15.8232 11.0126 15.8232 10.7197 15.5303L4.71967 9.53033C4.42678 9.23744 4.42678 8.76256 4.71967 8.46967L10.7197 2.46967C11.0126 2.17678 11.4874 2.17678 11.7803 2.46967Z"/>
            </svg>
        </div>
        <div id="profile-title" class="place-self-center">My Home</div>
        <div id="profile-menu"class="w-10 h-12 place-self-center" >
            <!--svg class="fill-secondary mt-3.5 m-auto" width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.5 3C10.5 3.82843 9.82843 4.5 9 4.5C8.17157 4.5 7.5 3.82843 7.5 3C7.5 2.17157 8.17157 1.5 9 1.5C9.82843 1.5 10.5 2.17157 10.5 3Z"/>
                <path d="M10.5 9C10.5 9.82843 9.82843 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9C7.5 8.17157 8.17157 7.5 9 7.5C9.82843 7.5 10.5 8.17157 10.5 9Z"/>
                <path d="M9 16.5C9.82843 16.5 10.5 15.8284 10.5 15C10.5 14.1716 9.82843 13.5 9 13.5C8.17157 13.5 7.5 14.1716 7.5 15C7.5 15.8284 8.17157 16.5 9 16.5Z"/>
            </svg-->
        </div>
    </section>
    <section id="tabs" class="flex my-8 space-x-9 font-extrabold text-secondary justify-center">
        <div id="recurring-btn" class="flex space-x-2 border border-shade p-2 rounded-sm bg-primary" on:click|stopPropagation={() => page.route(`/lists/recurring`)}>
            <span class="place-self-center cursor-pointer">{$count.user}</span>
            <img class="w-4.5 place-self-center m-auto" src="img/profiles/user.png" alt="">
        </div>
        <div id="recurring-btn" class="flex space-x-2 border border-shade p-2 rounded-sm bg-primary" on:click|stopPropagation={() => page.route(`/lists/recurring`)}>
            <span class="place-self-center cursor-pointer">{$count.baby}</span>
            <img class="w-4.5 place-self-center m-auto" src="img/profiles/baby.png" alt="">
        </div>
        <div id="recurring-btn" class="flex space-x-2 border border-shade p-2 rounded-sm bg-primary" on:click|stopPropagation={() => page.route(`/lists/recurring`)}>
            <span class="place-self-center cursor-pointer">{$count.pet}</span>
            <img class="w-4.5 place-self-center m-auto" src="img/profiles/pet.png" alt="">
        </div>
    </section>

    <section class="overflow-scroll no-scrollbar grow">
        <section id="profile-main-menu" class="flex flex-col space-y-3.5">
            <span>At the table</span>
            {#if $users}
                {#each $users as user}
                    <section id="menu-edit-appliances" class="h-24 rounded-3xl flex flex-row items-stretch bg-sunny" on:click|stopPropagation={() => modal.open(`/update-user?user_uid=${user.uid}&anchor=bottom`)}>
                        <div class="menu-card-icon w-20 shrink-0 flex">
                            <div class="bg-primary rounded-xl place-self-center p-2 h-16 w-16 flex">
                                <img class="w-7 place-self-center m-auto" src="img/profiles/{user.type}.png" alt="">
                            </div>
                        </div>
                        <section class="grow place-self-center content-start">
                            <div class="menu-card-title capitalize">{user.name}</div>
                            <div class="menu-card-desc text-xs pr-4 flex space-x-1.5">
                                <!--{#each user.diets as diet}
                                    {#each Object.entries(diet) as [key, has] }
                                        {#if has }
                                            <span class="text-xs italic capitalize">{key}</span>
                                        {/if}
                                    {/each}
                                {/each}
                                -->
                                {#if $restrictions[user.uid].length > 0 }
                                    {#each $restrictions[user.uid] as diet}
                                    <span class="text-xs italic capitalize">{diet}</span>
                                    {/each}
                                {:else}
                                <span class="text-xs italic">No restrictions</span>
                                {/if}
                            </div>
                        </section>
                        <div class="menu-card-go w-11 shrink-0">
                            <svg class="fill-primary w-4 h-4 mt-10" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.52858 2.19526C5.78892 1.93491 6.21103 1.93491 6.47138 2.19526L11.8047 7.5286C12.0651 7.78895 12.0651 8.21106 11.8047 8.4714L6.47138 13.8047C6.21103 14.0651 5.78892 14.0651 5.52858 13.8047C5.26823 13.5444 5.26823 13.1223 5.52858 12.8619L10.3905 8L5.52858 3.13807C5.26823 2.87772 5.26823 2.45561 5.52858 2.19526Z"/>
                            </svg>
                        </div>
                    </section>
                {/each}
            {/if}
        </section>
    </section>
    <section id="footer" class="m-auto my-8 cursor-pointer" on:click|stopPropagation={add}>
        Add someone
    </section>
</section>           

<style lang="postcss">

</style>
